import { extractWorkflowFromInstanceName } from '@spotify/confidence-core-react';
import { WorkflowInstanceRefFragment } from '@spotify/confidence-graphql';
import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';
import {
  useWorkflowExtension,
  workflowInstanceRouteRef,
} from '@spotify/plugin-confidence-workflows-react';

import { workflowsPlugin } from '../plugin';

const WorkflowInstanceResourceType = ({
  resource,
}: {
  resource: CollectionEntryOptions['resource'];
}) => {
  const { name } = resource as WorkflowInstanceRefFragment;
  const workflowId = extractWorkflowFromInstanceName(name);
  const extension = useWorkflowExtension({ workflowId: workflowId! });
  return <>{extension?.title ?? 'Experiment'}</>;
};

export const WorkflowInstanceCollectionEntryExtension = workflowsPlugin.provide(
  createCollectionEntryExtension({
    id: 'workflow-instance',
    resourceType: 'WorkflowInstance',
    routeRef: workflowInstanceRouteRef,
    getRouteParams: name => ({
      workflow: extractWorkflowFromInstanceName(name) || '',
    }),
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource &&
      resource.__typename === 'WorkflowV1WorkflowInstance',
    ResourceTypeLabel: WorkflowInstanceResourceType,
    render: () => null,
  }),
);
